
import EditComponent from "../../../components/lottery_coupons/Edit.vue";

export default {
  components: {
    EditComponent,
  },
};
